export default __webpack_public_path__ + "static/image-typemaster-landing-page-9bff47a880579b0734b2517652f582b3.png";